import axios from "axios";
import store from '@/store/index'
import router from "@/router";
import util from '@/utils/index';
import toast from '@/utils/toast';
import {
    autoLogin,
    setToken
} from "@/utils/user";


// 创建axios实例
const service = axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_CURRENTMODE === 'dev' ? '/' : process.env.VUE_APP_BASEURL, // api 的 base_url
    timeout: 50000 // 请求超时时间
});
// 模拟登录
const simulateService = axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_SIMULATE, // api 的 base_url
    timeout: 10000 // 请求超时时间
});
// 图片识别
const imgService = axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_OCR, // api 的 base_url
    timeout: 10000 // 请求超时时间
})
const axiosList = [service, imgService, simulateService]

for (const axiosService of axiosList) {
    // request拦截器
    axiosService.interceptors.request.use(
        config => {
            // console.log(store.state.h5authorization)
            if (store.state.h5authorization) {
                // 让每个请求携带自定义token 请根据实际情况自行修改
                if (store.state.isApp) {
                    config.headers["Authorization"] = store.state.h5authorization;
                } else {
                    config.headers["h5authorization"] = store.state.h5authorization;
                }
                config.headers["Content-Type"] = "application/json";
            }
            // 遮罩提示文字
            let message = "Loading...",
                // 是否展示加载遮罩
                isMask = true;
            // 参数
            const params = config.params || config.data;
            // console.log(params)
            // 车主抽奖
            if (params && params.lotteryToken) config.headers["token"] = params.lotteryToken;
            if (!util.objectIsEmpty(params)) {
                // 获取自定义提示文字
                message = params.toastMessage || message;
                // 判断是否展示加载遮罩
                isMask = !params.isNomask;
            }
            if (isMask) {
                // console.log(isMask)
                toast.loading(message);
            }
            return config;
        },
        error => {
            // console.log('error', error)
            return Promise.reject(error);
        }
    );

    // response 拦截器
    axiosService.interceptors.response.use(
        response => {
            hideToast(response)
            const data = response.data;
            let code = data.code || 0;
            // ocr识别接口
            if (data.log_id) {
                code = 1;
            }
            data.success = code === 1;
            if (code === 99) {
                // 登录超时处理
                if (store.state.isApp) {
                    autoLogin();
                } else {
                    setToken("");
                    router.push({
                        path: "/UserLogin"
                    });
                }
            } else if (data.data && data.data.records) {
                data.total = data.data.total;
                data.data = data.data.records;
            }
            return response;
        },
        error => {
            //     console.log("service error");
            hideToast(error);
            toast.fail('请求失败,服务端无法连接或出错！');
            return Promise.reject(error.response);
        }
    );
}

export function hideToast(res) {
    // console.log('hideToast')
    const config = res.config,
        params = config.params || config.data;
    let isMask = true;
    if (!util.objectIsEmpty(params)) {
        // 判断是否展示加载遮罩
        isMask = !params.isNomask;
    }
    // console.log(isMask)
    if (isMask) {
        toast.clear();
    }
}
// data 配置
// isSuccessToast 是否显示成功提示
// isNoToast 是否不显示所有提示
export function axiosRequest(axiosService, data, isSuccessToast = false, isNoToast = false) {
    return new Promise((resolve, reject) => {
        axiosService.request(data).then(res => {
            if (res) {
                const data = res.data,
                    success = data.success,
                    type = success ? 'success' : 'fail';
                // console.log(!success)
                let mes = data.msg;
                // 是否现实成功的提示
                if (isSuccessToast) {
                    if (!isNoToast) {
                        // 延迟执行，避免Toast.clear();还未执行
                        setTimeout(() => {
                            toast.show({
                                message: mes,
                                type: type
                            })
                        }, 100)
                    }
                }
                // 某些情况下后端错误消息放在data.data中以数组的形式
                if (!success) {
                    if (util.isArray(data.data)) {
                        mes = data.data[0].message;
                    }
                    if (!isNoToast) {
                        // 延迟执行，避免Toast.clear();还未执行
                        setTimeout(() => {
                            toast.show({
                                message: mes,
                                type: type
                            })
                        }, 100)
                    }
                }
                if (success) {
                    resolve(res);
                } else {
                    reject(res);
                }
            } else {
                reject(res);
            }
        }).catch(() => {
            reject({
                data: null
            });
        });
    });
}

export function simulateServiceRequest(data, isSuccessToast = false, isNoToast = false) {
    return axiosRequest(simulateService, data, isSuccessToast, isNoToast);
}

export function imgRequest(data, isSuccessToast = false, isNoToast = false) {
    return axiosRequest(imgService, data, isSuccessToast, isNoToast);
}

export function request(data, isSuccessToast = false, isNoToast = false) {
    return axiosRequest(service, data, isSuccessToast, isNoToast);
}

export function ajaxBack(data, isSuccessToast, isNoToast) {
    return new Promise((resolve, reject) => {
        request(data, isSuccessToast, isNoToast).then(res => {
            resolve(res.data);
        }).catch(res => {
            reject(res.data);
        });
    });
}

export function ajaxB(url, params, isSuccessToast, isNoToast) {
    return ajaxBack({
        url: url,
        method: "get",
        params: params
    }, isSuccessToast, isNoToast);
}

export function ajax(url, params, isSuccessToast, isNoToast) {
    return new Promise((resolve, reject) => {
        ajaxBack({
                url: url,
                method: "get",
                params: params
            },
            isSuccessToast, isNoToast
        ).then(res => {
            resolve(res);
        }).catch(res => {});
    });
}

export function ajaxP(url, params, isSuccessToast, isNoToast) {
    return new Promise((resolve) => {
        ajaxBack({
            url: url,
            method: 'post',
            params: params,
            data: params
        }, isSuccessToast, isNoToast).then(res => {
            resolve(res);
        }).catch(res => {});
    });
}
// 获取模拟数据
export function getJson(data) {
    return new Promise((resolve) => {
        resolve({
            success: true,
            data: data,
            total: 40
        });
    });
}
export default service;